import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { CATEGORY_LABELS } from "@/lib/format";
import { FileText, CheckCircle, Pencil, Mail, Plus } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  const cards = stats ? [
    { label: "Artikel gesamt", value: stats.total, icon: FileText },
    { label: "Veröffentlicht", value: stats.published, icon: CheckCircle },
    { label: "Entwürfe", value: stats.drafts, icon: Pencil },
    { label: "Newsletter-Abos", value: stats.subscribers, icon: Mail },
  ] : [];

  const maxCat = stats ? Math.max(1, ...stats.by_category.map((c) => c.count)) : 1;

  return (
    <AdminLayout title="Dashboard">
      <div className="flex justify-end mb-6">
        <Link to="/admin/artikel/neu" data-testid="admin-new-article-btn"
          className="inline-flex items-center gap-2 bg-gold text-prussian-dark font-body font-bold text-sm uppercase tracking-wide px-5 py-2.5 hover:bg-gold-hover">
          <Plus size={16} /> Neuer Artikel
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <div key={c.label} data-testid={`stat-${c.label}`} className="bg-white border border-edborder p-5">
            <div className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-wide text-muted-foreground font-body">{c.label}</span>
              <c.icon size={18} className="text-gold" />
            </div>
            <p className="font-headline font-black text-4xl text-prussian mt-2">{c.value}</p>
          </div>
        ))}
      </div>

      {stats && (
        <div className="bg-white border border-edborder p-6 mt-8 max-w-2xl">
          <h2 className="font-headline font-bold text-xl text-prussian mb-5">Verteilung nach Rubrik</h2>
          <div className="space-y-3">
            {stats.by_category.map((c) => (
              <div key={c.category} className="flex items-center gap-3">
                <span className="w-28 text-sm font-body text-charcoal">{CATEGORY_LABELS[c.category]}</span>
                <div className="flex-1 bg-offwhite h-6 border border-edborder">
                  <div className="h-full bg-prussian" style={{ width: `${(c.count / maxCat) * 100}%` }} />
                </div>
                <span className="w-8 text-right text-sm font-body font-semibold text-prussian">{c.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
